import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

interface NewsCardProps {
  item: NewsItem;
  layout?: "grid" | "row";
}

export default function NewsCard({ item, layout = "grid" }: NewsCardProps) {
  const badge = (
    <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium bg-accent-100 text-accent-800">
      {item.category}
    </span>
  );

  if (layout === "row") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg border border-background-200/80 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
      >
        <div className="relative w-full sm:w-56 shrink-0 aspect-[16/10] sm:aspect-auto sm:h-auto overflow-hidden bg-secondary-100">
          <img
            src={item.cover}
            alt={`影视资讯封面：${item.title}`}
            title={`${item.title} - 影视资讯`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4 sm:py-5 sm:pr-5 sm:pl-0 flex flex-col justify-center">
          <div className="flex items-center gap-3 mb-2">
            {badge}
            <span className="text-xs text-foreground-500">{item.date}</span>
          </div>
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{item.summary}</p>
          <p className="mt-3 text-xs text-foreground-400">{item.source}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200/80 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-secondary-100">
        <img
          src={item.cover}
          alt={`影视资讯封面：${item.title}`}
          title={`${item.title} - 影视资讯`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-3 mb-2">
          {badge}
          <span className="text-xs text-foreground-500">{item.date}</span>
        </div>
        <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 flex-1">{item.summary}</p>
        <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
        </div>
      </div>
    </Link>
  );
}